module.exports = __webpack_public_path__ + "static/img/warm_animate5.9ba96245.png";